import { forwardRef } from 'react';

const CardButtonSkeletonLoader = forwardRef<
  HTMLDivElement,
  React.ComponentProps<'div'>
>((props: React.ComponentProps<'div'>, forwardedRef) => {
  return (
    <div
      aria-busy="true"
      aria-label="Content is loading"
      className="border-mobile-gray-100 flex h-[72px] items-center gap-3 rounded-2xl border px-4 py-3"
      {...props}
      ref={forwardedRef}
    >
      <div className="bg-mobile-gray-50 h-12 animate-pulse rounded-full" />
      <div className="bg-mobile-gray-50 h-5 w-full animate-pulse rounded-3xl" />
    </div>
  );
});

CardButtonSkeletonLoader.displayName = 'CardButtonSkeletonLoader';

export default CardButtonSkeletonLoader;
